import { Stack } from '@adverity/design-system/components/stack'
import { Text } from '@adverity/ds-component/text'
import { IconCheckCircle } from '@adverity/ds-icon'

import type { PasswordRule } from '../utils'

type Props = {
    rules: ReadonlyArray<PasswordRule>
}

export const PasswordRules = ({ rules }: Props) => (
    <Stack spacing="x-small">
        <Text>Password must contain:</Text>

        <Stack spacing="xx-small" as="ul" className="list-none">
            {rules.map((rule) => (
                <Stack key={rule.text} as="li" spacing="xx-small" orientation="horizontal" alignItems="center">
                    <IconCheckCircle size="x-small" color={rule.valid ? 'brandHighlighted' : 'textSecondary'} />
                    <Text color={rule.valid ? 'brand' : undefined}>{rule.text}</Text>
                </Stack>
            ))}
        </Stack>
    </Stack>
)
